interface StatusBadgeProps {
  started: boolean;
  finished: boolean;
}

export const StatusBadge = ({ started, finished }: StatusBadgeProps) => {
  const label = finished ? 'Finished' : started ? 'In Progress' : 'Not Started';
  const className = finished
    ? 'tilo-badge tilo-badge--finished'
    : started
    ? 'tilo-badge tilo-badge--active'
    : 'tilo-badge tilo-badge--pending';

  return <span className={className}>{label}</span>;
};